import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';

const BannerDeleteModal = ({ open, setOpen, handleDelete }) => {
  const { t } = useTranslation();

  const deleteData = async () => {
    await handleDelete();
    setOpen(false);
  };

  return (
    <Box
      sx={{
        zIndex: '100',
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        display: open ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}>
      <Box
        sx={{
          minWidth: '400px',
          minHeight: '200px',
          borderRadius: '15px',
          border: '1px solid #00000010',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-around',
          background: '#fff',
          padding: '20px',
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: '18px',
            width: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
          }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: '20px', lineHeight: '17px', textAlign: 'center', color: 'firebrick' }}>
            {t('삭제하시겠습니까?')}
          </Typography>
          <Typography sx={{ fontWeight: 800, fontSize: '14px', lineHeight: '17px', textAlign: 'center', mt: '20px' }}>
            {t('삭제한 항목은 복구할 수 없습니다')}
          </Typography>
        </Box>

        <Box sx={{ mt: '20px', display: 'flex', justifyContent: 'center', alignItems: 'flex-end', width: '100%' }}>
          <Button
            onClick={e => setOpen(false)}
            sx={{
              p: '12px 37px 11px 37px',
              borderRadius: '5px',
              height: '36px',
              width: '100px',
              background: '#98A6AD',
              color: '#fff',
              '&:hover': { background: '#ddd' },
            }}>
            {t('Cancel')}
          </Button>
          <Button
            onClick={e => deleteData()}
            sx={{
              p: '12px 56px 11px 55px',
              borderRadius: '5px',
              height: '36px',
              width: '137px',
              background: '#0F7F85',
              color: '#fff',
              '&:hover': { background: '#0F7F85', color: '#fff' },
              ml: 2,
            }}>
            {t('Ok')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default BannerDeleteModal;
